import { computed, ref, watch } from "vue";

// rotaEmNavegacao é booleana, não contador: um guard pode redireccionar e
// fazer o Vue Router repetir o beforeEach sem um afterEach extra a condizer,
// o que deixaria um contador preso sem nunca voltar a zero.
const rotaEmNavegacao = ref(false);
const pendentesPagina = ref(0);
const quererMostrar = computed(
  () => rotaEmNavegacao.value || pendentesPagina.value > 0,
);

const isLoading = ref(false);
let temporizadorMostrar: ReturnType<typeof setTimeout> | null = null;
let inicioVisivelEm = 0;

const ATRASO_ANTES_DE_MOSTRAR_MS = 150;
const DURACAO_MINIMA_VISIVEL_MS = 300;

watch(
  quererMostrar,
  (querer) => {
    if (querer) {
      if (isLoading.value || temporizadorMostrar) return;
      temporizadorMostrar = setTimeout(() => {
        temporizadorMostrar = null;
        isLoading.value = true;
        inicioVisivelEm = Date.now();
      }, ATRASO_ANTES_DE_MOSTRAR_MS);
      return;
    }
    if (temporizadorMostrar) {
      // Nunca chegou a mostrar-se (ainda dentro do atraso) — nada a esconder.
      clearTimeout(temporizadorMostrar);
      temporizadorMostrar = null;
      return;
    }
    if (!isLoading.value) return;
    const tempoVisivel = Date.now() - inicioVisivelEm;
    const espera = Math.max(0, DURACAO_MINIMA_VISIVEL_MS - tempoVisivel);
    setTimeout(() => {
      if (!quererMostrar.value) isLoading.value = false;
    }, espera);
  },
  { immediate: true },
);

function iniciar() {
  rotaEmNavegacao.value = true;
}
function concluir() {
  rotaEmNavegacao.value = false;
}

export function useRouteLoading() {
  return { isLoading, iniciar, concluir };
}

/** Mantém o preloader visível até a promessa settle — para uma página com
 * carregamento próprio no onMounted não se mostrar sem dados por instantes. */
export function manterCarregandoEnquanto<T>(promessa: Promise<T>): Promise<T> {
  pendentesPagina.value += 1;
  return promessa.finally(() => {
    pendentesPagina.value = Math.max(0, pendentesPagina.value - 1);
  });
}
